import { InputNumber, Form } from 'antd';
import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './number.module.scss';
import { useState } from 'react';
import { useEffect } from 'react';

export default function NumberField({
  width,
  label,
  classLabel,
  classInput,
  mandatory = true,
  type,
  color,
  error,
  onChange,
  ...rest
}) {
  const noteLabel = (label) => {
    return (
      <span>
        <span style={{ color: 'red' }}>* </span>
        {label}
      </span>
    );
  };
  return (
    <div>
      <Form.Item
        label={mandatory ? noteLabel(label) : label}
        className={cx(styles.FormItem, classLabel)}
      >
        <InputNumber
          type="number"
          style={{
            width: width || '100%',
            color: color || '#000000a6',
            borderColor: error ? 'red' : '#d9d9d9',
          }}
          className={cx(styles[type], styles.Input, classInput)}
          onChange={onChange}
          {...rest}
        />
      </Form.Item>
    </div>
  );
}
NumberField.propTypes = {
  width: PropTypes.string,
};
